import styled from "@emotion/styled";
import React from "react";
import { MovieBrowser } from "./movieBrowser";

function App() {
  return (
    <div className="App">
      <Header>Shudder Archives</Header>
      <span>
        <RootLink
          href={"https://skeleton.club/posts/post/2022-03-20.html"}
          target="_blank"
        >
          (find out more)
        </RootLink>
      </span>
      <MovieBrowser />
    </div>
  );
}

export default App;

const Header = styled.h2({ color: "#f5f5f5" });
const RootLink = styled.a({ color: "grey", textDecoration: "none" });
